import styled from 'styled-components';

export const CustomField = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
`;

export const StyledLabel = styled.label`
  margin-bottom: 5px;
  text-transform: uppercase;
  font-weight: 600;
`;
